import axios from 'axios';
import { WORKING_HOURS_ENDPOINT } from '../constants/endpoint';
import config from '../config';

const GetWorkingHours = async () => {
  try {
    const res = await axios.get(`${WORKING_HOURS_ENDPOINT}`, { headers: { 'x-api-key': config.PORTAL_SUPPORT_API_KEY } });
    return res;
  } catch (err) {
    const message = err.response?.data?.message;
    throw message || err;
  }
};

export { GetWorkingHours };
